 <form class="needs-validation" [formGroup]="form" novalidate>



            <div class="row">
                <div class="col-md-12">

                    <div class="card card-accent-success animated fadeIn">

                        <a class="card-header-a" (click)="isCollapsedDatosPif = !isCollapsedDatosPif" [attr.aria-expanded]="!isCollapsedDatosPif"
                           aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos Punto Inspección.
                                <i *ngIf="isCollapsedDatosPif" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedDatosPif" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">

                            <div class="collapse group-campos" id="isCollapsedDatosPif" [ngbCollapse]="isCollapsedDatosPif">

                                <div class="row">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label required-field" for="inpDescripcion">Descripción</label>
                                        <input formControlName="Descripcion" name="Descripcion" title="" class="form-control"
                                               maxlength="100" [ngClass]="displayFieldCss('Descripcion')" id="inpDescripcion" type="text" value="">

                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('Descripcion','required')">
                                            Descripcion es obligatorio
                                        </div>

                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('Descripcion','descripcion_duplicated')">
                                            Descripción ya existe
                                        </div>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" [ngClass]="{ 'required-field' : isEspania() }" for="inpCodigo">Código</label>
                                        <input formControlName="Codigo" numbersOnly name="Codigo" maxlength="3" title="" class="form-control"
                                               id="inpCodigo" [ngClass]="displayFieldCss('Codigo')" type="text" value="">

                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('Codigo','required')">
                                            Código es obligatorio
                                        </div>

                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('Codigo','pattern')">
                                            Formato incorrecto
                                        </div>

                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('Codigo','codigo_duplicated')">
                                            El Código ya existe
                                        </div>

                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="inpTipo" [ngClass]="{ 'required-field' : isEspania() }">Tipo</label>

                                        <ng-select #municipio loadingText="Cargando..."
                                                   [items]="listTipoPuntoInspeccion"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdTipoPuntoInspeccion"
                                                   [loading]="(!(listTipoPuntoInspeccion) && (isEspania()))"
                                                   notFoundText="Tipo Punto Inspección no encontrado"
                                                   placeholder="-- Seleccione un Tipo --"
                                                   [ngClass]="displayFieldCssNgSelect('IdTipoPuntoInspeccion')"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdTipoPuntoInspeccion','required')">
                                            Tipo es obligatorio
                                        </div>
                                    </div>

                                </div>

                                <div class="row">

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label required-field" for="inpPais">País</label>

                                        <ng-select loadingText="Cargando..."
                                                   [items]="listPais"
                                                   placeholder="-- Seleccione un País --"
                                                   [loading]="!(listPais)"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdPais"
                                                   notFoundText="País no encontrado"
                                                   [ngClass]="displayFieldCssNgSelect('IdPais')"
                                                   clearAllText="Eliminar selección"
                                                   (change)="onSelectPais()">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPais','required')">
                                            País es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="intZona" [ngClass]="{ 'required-field' : isEspania() }">Zona</label>

                                        <ng-select loadingText="Cargando..."
                                                   [items]="listZona"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdZona"
                                                   [loading]="(!(listZona) && (isEspania()))"
                                                   notFoundText="Zona no encontrada"
                                                   placeholder="-- Seleccione una Zona --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdZona')"
                                                   (change)="onSelectZona()">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdZona','required')">
                                            Zona es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="inpProvincia" [ngClass]="{ 'required-field' : isEspania() }">Provincia</label>

                                        <ng-select loadingText="Cargando..."
                                                   [items]="listProvincia"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdProvincia"
                                                   [loading]="(!(listProvincia) && (isEspania()) && (form.value.IdZona > 0))"
                                                   notFoundText="Provincia no encontrada"
                                                   placeholder="-- Seleccione una Provincia --"
                                                   clearAllText="Eliminar selección"
                                                   [disabled]="!isEspania()"
                                                   [ngClass]="displayFieldCssNgSelect('IdProvincia')"
                                                   (change)="onSelectProvincia()">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdProvincia','required')">
                                            Provincia es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="inpMunicipio" [ngClass]="{ 'required-field' : isEspania() }">Municipio</label>
                                        <ng-select #municipio loadingText="Cargando..."
                                                   [items]="listMunicipio"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdMunicipio"
                                                   [loading]="(!(listMunicipio) && (isEspania()) && (form.value.IdProvincia > 0))"
                                                   notFoundText="Municipio no encontrado"
                                                   placeholder="-- Seleccione un Municipio --"
                                                   [ngClass]="displayFieldCssNgSelect('IdMunicipio')"
                                                   (change)="onSelectMunicipio()"
                                                   clearAllText="Eliminar selección">

                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                            </ng-template>

                                        </ng-select>
                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdMunicipio','required')">
                                            Municipio es obligatorio
                                        </div>
                                    </div>

                                </div>

                                <div class="row">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label required-field" for="inpLocalidad">Localidad</label>
                                        <input formControlName="Localidad" name="Localidad" title="" maxlength="150"
                                               [ngClass]="displayFieldCss('Localidad')" class="form-control" id="inpLocalidad" type="text" value="">

                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('Localidad','required')">
                                            Localidad es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label required-field" for="inpDescripcion">Código Traces</label>
                                        <input formControlName="CodigoTraces" name="CodigoTraces" title="" class="form-control"
                                               maxlength="30"
                                               [ngClass]="displayFieldCss('CodigoTraces')" id="inpDescripcion" type="text" value="">

                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoTraces','required')">
                                            Código Traces es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label required-field" for="inpCodigoPostal">Código Postal</label>
                                        <input class="form-control" formControlName="CodigoPostal" maxlength="15"
                                               inputStyleClass="form-control" id="inpCodPostal"
                                               value="" [ngClass]="displayFieldCss('CodigoPostal')">
                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoPostal','pattern')">
                                            Formato incorrecto
                                        </div>
                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoPostal','required')">
                                            Código postal es obligatorio
                                        </div>

                                    </div>

                                </div>


                                <div class="row">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="inpDescripcion">Email</label>
                                        <input formControlName="Email" name="Descripcion" title="" class="form-control"
                                               maxlength="100"
                                               [ngClass]="displayFieldCssNoSubmit('Email')" id="inpDescripcion" type="text" value="">

                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('Email','email')">
                                            Formato incorrecto
                                        </div>
                                    </div>                                 

                                </div>

                                <div class="row">

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="inpDescripcion">Activo</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="Activo" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                        offIcon="pi pi-times"></p-toggleButton>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="tbHabImp">Habilitado Importación</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="HabilitadoParaImportacion" onLabel="Sí" offLabel="NO"
                                                        onIcon="pi pi-check" offIcon="pi pi-times" id="tbHabImp"></p-toggleButton>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="tbHabExp">Habilitado Exportación</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="HabilitadoParaExportacion" onLabel="Sí" offLabel="NO"
                                                        onIcon="pi pi-check" offIcon="pi pi-times" id="tbHabImp"></p-toggleButton>
                                    </div>


                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="tbHabSanEX">Habilitado Higiene</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="HabilitadoSanidadExterior" onLabel="Sí" offLabel="NO"
                                                        onIcon="pi pi-check" offIcon="pi pi-times" id="tbHabImp"></p-toggleButton>
                                    </div>                                   
                                </div>

                            </div>
                        </div>

                    </div>

                    <div *ngIf="form.get('HabilitadoParaExportacion')?.value === true"  class="card card-accent-success animated fadeIn">

                        <a class="card-header-a" (click)="isCollapsedDatosReasignable = !isCollapsedDatosReasignable" [attr.aria-expanded]="!isCollapsedDatosReasignable"
                           aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Distribución Automática de Solicitudes de Export UK.
                                <i *ngIf="isCollapsedDatosReasignable" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedDatosReasignable" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">

                            <div class="collapse group-campos" id="isCollapsedDatosReasignable" [ngbCollapse]="isCollapsedDatosReasignable">     

                                <div class="row">

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="tbHabSanEX">Reasignable</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="ReasignableEx" onLabel="Sí" offLabel="NO"
                                                        onIcon="pi pi-check" offIcon="pi pi-times" id="tbHabImp"></p-toggleButton>
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="tbHabSanEX">Fines de semana</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="FinesDeSemana" onLabel="Sí" offLabel="NO"
                                                        onIcon="pi pi-check" offIcon="pi pi-times" id="tbHabImp"></p-toggleButton>
                                    </div>                                    

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>


            

     

</form>
